import type React from "react";

import { useRemoveProposalSocialHttp } from "../../hooks/http/proposal-socials/remove-proposal-social.hook";
import { useNavigate, useParams } from "react-router-dom";
import { XIcon } from "lucide-react";
import { handleHttpError } from "../../../utils/utils";
import Button from "../../components/core/button.core";
import { useToast } from "../../../hooks/use-toast";
import useProposalSocialStore from "../../store/proposal-social.store";
import { useUserStore } from "../../../store/user.store";
import useProposalSocialSearchStore from "../../store/proposal-socials-search.store";

export const RemoveSocialFromProposal: React.FunctionComponent<{
  id: string;
  searching: boolean;
}> = ({ id, searching }) => {
  const {
    execute: removeProposalSocialHttp,
    fetching: removingProposalSocial,
  } = useRemoveProposalSocialHttp();
  const { toast } = useToast();
  const { proposalId } = useParams();
  const { removeById } = useProposalSocialStore();
  const { setData: setSearchData, data: searchData } =
    useProposalSocialSearchStore();
  const { token, brands } = useUserStore();
  const navigate = useNavigate();

  const brandId = brands?.[0]?.id;

  async function removeSocialFromProposal() {
    if (!token) {
      toast({
        content: "Please login to remove social",
        toastType: "error",
      });
      navigate(
        `/brands/auth/login?proposalId=${proposalId}&brandId=${brandId}`
      );
      return;
    }
    if (!proposalId) {
      return;
    }
    const response = await removeProposalSocialHttp({
      body: null,
      pathParams: {
        proposalId,
        proposalSocialId: id,
      },
    });
    if (!response.success) {
      return handleHttpError(response, toast);
    }
    toast({
      content: "Social removed from proposal",
      toastType: "success",
    });
    if (searching) {
      setSearchData(
        searchData.map((item) =>
          item.proposalSocial?.id === id
            ? { ...item, proposalSocial: null }
            : item
        )
      );
      return;
    }
    removeById(id);
  }

  return (
    <Button
      variant="red"
      isLoading={removingProposalSocial}
      onClick={removeSocialFromProposal}
      className="p-0 w-14 h-14 font-semibold tracking-wider"
    >
      <XIcon />
    </Button>
  );
};
